<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="form-group">
    <label class="form-label">Name</label>
    <input formControlName="name" type="text" class="form-control" required />
    <input-errors [control]="form.controls.name" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label">ISO</label>
    <input formControlName="isoAlpha2" type="text" class="form-control" required />
    <input-errors [control]="form.controls.isoAlpha2" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label">Prefixes</label>
    <input formControlName="prefixes" type="text" class="form-control" placeholder="Separate multiple prefixes by comma" required />
    <input-errors [control]="form.controls.prefixes" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label">Language</label>
    <select formControlName="languageCode" class="form-control">
      <option *ngFor="let lang of languages" [value]="lang.code">{{ lang.name }}</option>
    </select>
    <input-errors [control]="form.controls.languageCode" [service]="validationService"></input-errors>
  </div>
  <div class="text-right mt-10">
    <a *ngIf="backButtonShow" href="javascript:history.back();" class="btn btn-danger m-b m-r">Cancel</a>
    <button id="btn-sender-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary mb-10 px-15">Apply</button>
  </div>
</form>
